import { useParams, useNavigate } from 'react-router-dom';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function ProjectDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  // Project data - in a real app, this would come from an API or database
  const projectData = {
    '1': {
      title: 'Limpsfield Road, Warlingham',
      category: 'Residential',
      location: 'Surrey',
      description: '100 dwellings, including 40% affordable housing, with associated infrastructure, landscaping, and replacement sports facilities.',
      features: ['100 Units', 'S278', 'S104', 'S38'],
      fullDescription: 'Vine Consulting Engineers provided civil engineering design and advisory services to award-winning developer Cala Homes. Our involvement included preparation of the detailed design pack, supporting submissions to gain technical approvals and discharge planning conditions, and providing ongoing technical support during construction.\n\nThe dwellings were designed to M4(1) and M4(2) accessibility standards, with adoptable estate roads and NHBC-compliant civil engineering works. Post-construction drainage verification incorporated key SuDS features, including permeable paving, attenuation storage and basin, and deep boreholes.\n\nThe project also involved coordination of infrastructure delivered under Section 278, Section 104, and Section 38 agreements, ensuring integration with existing highway and drainage networks.',
      heroImage: 'https://static.readdy.ai/image/25bd6a9c0c5cf960313d03e8d1447d98/8a6d3666ad0de7f392601cf223d368e8.jpeg',
      images: [
        'https://static.readdy.ai/image/25bd6a9c0c5cf960313d03e8d1447d98/92ebae4f1ba859698c5079d2099f6f71.png',
        'https://static.readdy.ai/image/25bd6a9c0c5cf960313d03e8d1447d98/398a9d3766bfe9553a6a0361eb5977b5.png',
        'https://static.readdy.ai/image/25bd6a9c0c5cf960313d03e8d1447d98/f9d1dc63fc9c5fdb7ece796422bc55c9.png',
        'https://static.readdy.ai/image/25bd6a9c0c5cf960313d03e8d1447d98/35c0fe3aadaed69b9063999d73a1c1e4.png',
        'https://static.readdy.ai/image/25bd6a9c0c5cf960313d03e8d1447d98/f73bef550d17d7d47c9ff9a0e6bde0b1.png'
      ]
    },
    '2': {
      title: 'Coxbridge Farm',
      category: 'Infrastructure',
      location: 'Surrey',
      description: 'Section 278 works to deliver highway infrastructure for a new 320-residential unit development, including a new PROW link to an existing public right of way.',
      features: ['S278', 'Right turn lanes', 'PROW', 'Toucan Crossing'],
      fullDescription: 'Vine Consulting Engineers provided civil engineering design and advisory services to award-winning developer Cala Homes for the Coxbridge Farm development.\n\nThe highway works comprised circa 450m of improvements to West Street  in Farnham, Surrey. This included a new shared pedestrian and cycleway footway achieved by narrowing the carriageway, enhancements to existing bus stops via provision of bus shelters and RTPI, a pair of opposing right-turn lanes, a new Toucan crossing, and a priority junction to access the development. Our involvement included preparation of a combined Section 278 and Section 38 application for the highway works, liaising with Surrey County Council to secure technical acceptance of the design, and providing ongoing technical support during construction.\n\nThe Public Right of Way (PROW) works included the delivery of a circa 270m unbound route connecting to existing Public Footpath No. 167, providing a safe and accessible link through open land for pedestrians, dog walkers, and local residents between the new development and Farnham town centre. Our involvement included preparation of the Section 25 application and gaining technical acceptance.',
      heroImage: 'https://static.readdy.ai/image/25bd6a9c0c5cf960313d03e8d1447d98/7aacc6141e8601e9c02443b811c08508.png',
      images: [
        'https://static.readdy.ai/image/25bd6a9c0c5cf960313d03e8d1447d98/40aaedc45ba94e2c52936b957b4d7ddf.png',
        'https://static.readdy.ai/image/25bd6a9c0c5cf960313d03e8d1447d98/5aca3b5fe00322639aa3925033b6eb7b.png',
        'https://static.readdy.ai/image/25bd6a9c0c5cf960313d03e8d1447d98/a69c3a2d70038b3130e46420aee26d72.png',
        'https://static.readdy.ai/image/25bd6a9c0c5cf960313d03e8d1447d98/33bff11db994ea503b31ff0fce93d49e.png',
        'https://static.readdy.ai/image/25bd6a9c0c5cf960313d03e8d1447d98/98171ed12ac548edad7443f4010426d8.png'
      ]
    },
    '3': {
      title: 'Ash',
      category: 'Residential',
      location: 'Surrey',
      description: '68 dwellings, including affordable housing, with associated infrastructure and landscaping.',
      features: ['68 Units', 'S278', 'S104', 'S38'],
      fullDescription: 'Vine Consulting Engineers provided comprehensive civil engineering design and advisory services for award-winning developer Persimmon Homes for the Ash development, which comprises 68 M4(1) and M4(2) accessible dwellings. Our involvement included the preparation of the full detailed civil engineering design pack, alongside all necessary Section 278, Section 38, and Section 104 applications, with technical approval secured for all submissions.\n\nThe highway works included improvement works under a S278 application and the construction of adoptable estate roads under a S38 agreement with Surrey County Council. A shared footway/cycleway within the development was designed to connect with the wider offsite cycling infrastructure, providing safe and accessible pedestrian and cyclist routes.\n\nThe drainage infrastructure was designed to adoptable standards under a S104 application. Sustainable Urban Drainage Systems (SuDS) incorporated storage attenuation tanks, permeable paving, and an attenuation basin to manage surface water and reduce flood risk. Design challenges included a very flat site and constraints imposed by surrounding infrastructure, which were addressed through optimising site levels and hydraulic performance.',
      heroImage: 'https://static.readdy.ai/image/25bd6a9c0c5cf960313d03e8d1447d98/0dc6638d84260ab17158f3fa3014366d.png',
      images: [
        'https://public.readdy.ai/ai/img_res/3f00ac3aa9a7e76132f6ac35c887281d.jpg',
        'https://static.readdy.ai/image/25bd6a9c0c5cf960313d03e8d1447d98/9f0abbf97d21eb49499b3cee59b478bd.png',
        'https://static.readdy.ai/image/25bd6a9c0c5cf960313d03e8d1447d98/295033379103fd5600dca9d76c8fd549.png',
        'https://static.readdy.ai/image/25bd6a9c0c5cf960313d03e8d1447d98/765f3a68d6ae5536a2354d8bb8c5328c.png',
        'https://static.readdy.ai/image/25bd6a9c0c5cf960313d03e8d1447d98/349f3a9db2a2e2da45560d1fd43e1c32.png'
      ]
    }
  };

  const project = projectData[id as keyof typeof projectData];

  if (!project) {
    return (
      <div className="min-h-screen bg-stone-50">
        <Header />
        <div className="container mx-auto px-6 py-20 text-center">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">Project Not Found</h1>
          <button 
            onClick={() => navigate('/')}
            className="bg-emerald-600 text-white px-8 py-3 rounded-lg hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            Back to Home
          </button>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-stone-50">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative pt-32 pb-12 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('${project.heroImage}')`
        }}
      >
        <div className="container mx-auto px-6">
          <button 
            onClick={() => navigate('/')}
            className="flex items-center text-white hover:text-emerald-300 mb-6 cursor-pointer transition-colors"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            <span>Back to Projects</span>
          </button>
          
          <div className="max-w-4xl">
            <div className="flex items-center gap-3 mb-4">
              <span className="bg-emerald-600 text-white px-4 py-1 rounded-full text-sm font-medium">
                {project.category}
              </span>
              <div className="flex items-center text-white">
                <i className="ri-map-pin-line mr-2"></i>
                <span>{project.location}</span>
              </div>
            </div>
            
            <h1 className="text-5xl font-bold text-white mb-4">{project.title}</h1>
            <p className="text-xl text-gray-100 mb-6">{project.description}</p>
            
            <div className="flex flex-wrap gap-3">
              {project.features.map((feature, index) => (
                <span key={index} className="bg-white/90 text-gray-700 px-4 py-2 rounded-full text-sm border border-stone-200 font-medium">
                  {feature}
                </span>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            {/* Project Description */}
            <div className="mb-16">
              <h2 className="text-3xl font-bold text-gray-800 mb-6">Project Overview</h2>
              <div className="prose prose-lg max-w-none">
                {project.fullDescription.split('\n\n').map((paragraph, index) => (
                  <p key={index} className="text-gray-600 leading-relaxed mb-4">
                    {paragraph}
                  </p>
                ))}
              </div>
            </div>

            {/* Project Images Gallery */}
            <div className="mb-16">
              <h2 className="text-3xl font-bold text-gray-800 mb-6">Project Gallery</h2>
              
              {/* Additional Images Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {project.images.slice(1).map((image, index) => (
                  <div key={index} className="rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                    <img 
                      src={image}
                      alt={`${project.title} - View ${index + 2}`}
                      className="w-full h-[300px] object-cover object-top hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
